import { BackArrow } from 'src/shared/components/icons/back-arrow'
import { useWindowSize } from 'src/shared/hooks/use-window-size'

type SectionTitleProps = {
  title: string | React.ReactNode
  rightContent?: React.ReactNode
  onGoBack?: () => void
  forceShow?: boolean
}

const SectionTitle = ({ title, rightContent, onGoBack, forceShow }: SectionTitleProps) => {
  const { width } = useWindowSize()
  if (width < 768 && !forceShow) return null

  return (
    <div className="flex items-center justify-center gap-6 md:justify-between">
      <div className="flex items-center gap-2 md:gap-4">
        {onGoBack && (
          <button
            onClick={onGoBack}
            className="flex size-6 items-center justify-center rounded-full border border-border bg-accent text-primary md:size-10"
          >
            <BackArrow className="size-3 md:size-5" />
          </button>
        )}
        <h2 className="text-sm font-semibold text-muted md:text-[24px] md:text-primary">{title}</h2>
      </div>
      {rightContent}
    </div>
  )
}

export default SectionTitle
